module.exports = __webpack_public_path__ + "14four/static/media/fingerIcon.4e5d3aae.png";